import React, { useEffect, useState } from 'react';
import {ReactComponent as Icon } from '../../assets/icons/Edit.svg'
import { useNavigate } from 'react-router-dom';
import TableMedusa from '../../components/Table';
import { Table, Button } from '@mantine/core';
import { ModelsDetailRowType, ModelDetailListProps } from "../../types/models";
import {useDisclosure } from '@mantine/hooks';
import ModelsDetailsPopUp from './ModelsDetailsPopUp';
import {ReactComponent as RemoveIcon} from '../../assets/icons/Remove.svg'
import PopUp from '../../components/PopUp';
import { useCategories } from '../../context/CategoriesContext';





const ModelsDetailsList = ({data, activeTab, deleteDetail, onSave }: ModelDetailListProps) => {
    const { recyclingCat, reuseCat, colorCat } = useCategories();
    const icon = <Icon width={19} height={19}></Icon>;
    const removeIcon = <RemoveIcon width={19} height={19}></RemoveIcon>;
    const [editModelLabel, setEditModelLabel] = useState<ModelsDetailRowType | null>(null);
    const [deleteModelLabel, setDeleteModelLabel] = useState<ModelsDetailRowType | null>(null);
    const [opened, { open, close }] = useDisclosure(false);
    const [openedDel, handlerDel] = useDisclosure(false);
    
    
    let table = null;

    const onClickDetail = (id:number | undefined)=>{
        if (id === undefined) return;
        const model = data?.find((item) => item.id === id) || null;
        setEditModelLabel(model);
        open();
    }

    const onClickRemove = (id:number | undefined)=>{
        if (id === undefined) return;
        setDeleteModelLabel(data?.find((item) => item.id === id) || null);
        handlerDel.open();
    }

    const onClickDelete = (id:number | undefined)=>{
        if (id !== undefined) {
            deleteDetail(id);
        }
        setDeleteModelLabel(null);
        handlerDel.close();
    }

    if (activeTab === 'Color') {
        const sortedData = [...(data ?? [])].sort(
        (a, b) => (a.model_label ?? 0) - (b.model_label ?? 0)
        );
        const rows = sortedData.map(({ id, sorter_model_id, model_label, color_id }) => {
            const categoryName = colorCat.find((cat) => cat.id === color_id)?.name || color_id || '-';
            return (
                <Table.Tr key={id}>
                    <Table.Td>{id}</Table.Td>
                    <Table.Td>{model_label}</Table.Td>
                    <Table.Td>{categoryName}</Table.Td>
                    <Table.Td>
                        <Button variant="transparent" onClick={()=>onClickDetail(id)}>{icon}</Button>
                        <Button variant="transparent" onClick={()=>onClickRemove(id)}>{removeIcon}</Button>
                    </Table.Td>
                </Table.Tr>
            );
        });
        table = <TableMedusa headers={["ID", "Model Label", "Color", "Actions"]} rows={rows}></TableMedusa>
     } else if (activeTab === 'Recycling') {
        const sortedData = [...(data ?? [])].sort(
            (a, b) => (a.order ?? 0) - (b.order ?? 0)
            );
        const rows = sortedData.map(({ id, sorter_model_id, model_label, recycling_category_id, order, boolean_expression}) => {
            const categoryName = recyclingCat.find((cat) => cat.id === recycling_category_id)?.name || recycling_category_id || '-';
            return (
                <Table.Tr key={id}>
                    <Table.Td>{id}</Table.Td>
                    <Table.Td>{order}</Table.Td>
                    <Table.Td>{model_label}</Table.Td>
                    <Table.Td>{boolean_expression}</Table.Td>
                    <Table.Td>{categoryName}</Table.Td>
                    <Table.Td>
                        <Button variant="transparent" onClick={()=>onClickDetail(id)}>{icon}</Button>
                        <Button variant="transparent" onClick={()=>onClickRemove(id)}>{removeIcon}</Button>
                    </Table.Td>
                </Table.Tr>
            );
        });
        table = <TableMedusa headers={["ID", "Order", "Model Label", "Boolean Expression", "Recycling Category", "Actions"]} rows={rows}></TableMedusa>
     } else if (activeTab === 'Reuse') {
        const sortedData = [...(data ?? [])].sort(
        (a, b) => (a.model_label ?? 0) - (b.model_label ?? 0)
        );
        const rows = sortedData?.map(({ id, sorter_model_id, model_label, reuse_category_id }) => {
            const categoryName = reuseCat.find((cat) => cat.id === reuse_category_id)?.name || reuse_category_id || '-';
            return (
                <Table.Tr key={id}>
                    <Table.Td>{id}</Table.Td>
                    <Table.Td>{model_label}</Table.Td>
                    <Table.Td>{categoryName}</Table.Td>
                    <Table.Td>
                        <Button variant="transparent" onClick={()=>onClickDetail(id)}>{icon}</Button>
                        <Button variant="transparent" onClick={()=>onClickRemove(id)}>{removeIcon}</Button>
                    </Table.Td>
                </Table.Tr>
            );
        });
        table = <TableMedusa headers={["ID", "Model Label", "Reuse Category", "Actions"]} rows={rows}></TableMedusa>
    }

    return(
            <div>
                <PopUp opened={openedDel} close={handlerDel.close} size={700} title="Warning" onSave={() => onClickDelete(deleteModelLabel?.id)} button1="Delete" >Are you sure you want to delete this label?</PopUp>
                <ModelsDetailsPopUp
                    opened={opened}
                    close={close}
                    title={"Edit"}
                    onSave={onSave}
                    modelLabel={editModelLabel}
                    activeTab={activeTab}
                    existingModelLabels={(data ?? []).map((item) => item.model_label)}
                ></ModelsDetailsPopUp>
                {table}
            </div>
    )
}

export default ModelsDetailsList;